'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _AdvancingText = require('../ui/AdvancingText');

var _AdvancingText2 = _interopRequireDefault(_AdvancingText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Group) {
  _inherits(_class, _Phaser$Group);

  function _class(_ref) {
    var game = _ref.game,
        onClick = _ref.onClick,
        onClickContext = _ref.onClickContext;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game));

    _this.modal = game.add.graphics(0, 0);
    _this.modal.beginFill(0xFFFF00, 0);
    _this.modal.bounds = new PIXI.Rectangle(0, 0, game.world.width, game.world.height);
    _this.modal.drawRect(0, 0, game.world.width, game.world.height);
    _this.modal.boundsPadding = 0;
    _this.modal.inputEnabled = true;
    _this.modal.events.onInputDown.add(onClick, onClickContext, 0);
    _this.add(_this.modal);

    _this.bar = game.add.graphics(0, game.world.height - 63);
    _this.bar.beginFill(0x000000, 0.8);
    _this.bar.bounds = new PIXI.Rectangle(0, 0, game.world.width, 50);
    _this.bar.drawRect(0, 0, game.world.width, 50);
    _this.bar.boundsPadding = 0;
    _this.add(_this.bar);

    _this.text = new _AdvancingText2.default({
      game: game,
      y: game.world.height - 50
    });
    _this.text.x = game.world.width * 0.5;
    return _this;
  }

  _createClass(_class, [{
    key: 'destroy',
    value: function destroy() {
      this.modal.destroy();
      this.bar.destroy();
      this.text.destroy();
    }
  }, {
    key: 'setText',
    value: function setText(line) {
      this.text.setText(line);
    }
  }, {
    key: 'update',
    value: function update() {
      this.text.next();
    }
  }]);

  return _class;
}(_phaser2.default.Group);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/ui/Dialogue.js
// module id = 350
// module chunks = 0